import { render, staticRenderFns } from "./PasswordResetPanel.vue?vue&type=template&id=86e6dbea&scoped=true"
import script from "./PasswordResetPanel.vue?vue&type=script&lang=js"
export * from "./PasswordResetPanel.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetPanel.vue?vue&type=style&index=0&id=86e6dbea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e6dbea",
  null
  
)

export default component.exports